exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  width: 100%;\n  height: 100%; }\n\n.map-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 300px;\n  overflow: hidden; }\n\n.map {\n  width: 100%;\n  height: 100%; }\n\n.snapshot-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 1000;\n  padding: 10px 15px;\n  background: white;\n  border: 2px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3); }\n  .snapshot-btn:hover {\n    background: #f5f5f5; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/shared/google-map/google-map.component.scss
// module id = ../../../../../src/app/shared/google-map/google-map.component.scss
// module chunks = main